import generatorApi from '../api/generator';
import { transformPages } from './utils';

/**
 * Generate pages from photo source. Sync call.
 * @param {string} accessToken
 * @param {object} template
 * @param {Array} photos
 * @param {string} pageId
 * @returns {{ data: { pages: Array, photos: Array }, error: string }}
 */
const generateClassicData = async (accessToken, template, photos, pageId = '') => {
  const { data, error } = await generatorApi(accessToken, template, false).getPhotoData(
    photos,
    pageId,
  );

  if (error) {
    return {
      error,
    };
  }

  const pages = transformPages(template, photos, data);

  if (pages.length === 0) {
    return { error: 'The generator returns empty pages.' };
  }

  return {
    data: {
      photos,
      pages,
    },
  };
};

export default generateClassicData;
